import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref, shallowRef, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import axios from '@nextcloud/axios';
import { getLanguage } from '@nextcloud/l10n';

import FolderGrid from './FolderGrid.vue';

import { config } from '@services/user-config';
import { useRouteState } from '@services/route-state';
import { API } from '@services/API';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import * as utils from '@services/utils/common';

import type { IFolder } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'FolderDynamicTopMatter',
},
  __name: 'FolderDynamicTopMatter',
  emits: ["load"],
  setup(__props, { expose: __expose, emit: __emit }) {



const emit = __emit;

const route = useRoute();

const folders = shallowRef<IFolder[] | null>(null);
const currentFolder = ref('<none>');
const abort = useAbort();

useRouteState({
  state: { folders, currentFolder },
});

const isReady = computed((): boolean => folders.value !== null);
const isContent = computed((): boolean => !!folders.value?.length && !route.query.recursive);

function folder(): string {
  return utils.getFolderRoutePath(config.folders_path, { route });
}

async function refresh(): Promise<void> {
  const folderVal = folder();

  // Clear folders if switching to a different folder, otherwise just refresh
  if (currentFolder.value !== folderVal) {
    currentFolder.value = folderVal;
    folders.value = null;
  }

  // Create an abort signal for this request.
  const signal = abort.renew();

  // Get subfolders URL
  const url = API.Q(API.FOLDERS_SUB(), { folder: folderVal });

  // Make API call to get subfolders
  try {
    const data = (await axios.get<IFolder[]>(url, { signal })).data;
    signal.throwIfAborted();
    folders.value = data;
  } catch (e) {
    if (isAbortError(e)) return;
    console.error(e);
    return;
  } finally {
    if (!signal.aborted) {
      folders.value ??= [];
    }
  }

  // Filter out hidden folders
  if (!config.show_hidden_folders) {
    folders.value = folders.value.filter((f) => !f.name.startsWith('.') && f.previews?.length);
  }

  // Sort folders by name, case insensitive and natural
  folders.value.sort((a, b) => a.name.localeCompare(b.name, getLanguage(), { numeric: true }));

  emit('load');
}

onMounted(refresh);

__expose({ isReady, isContent, refresh });

return (_ctx: any,_cache: any) => {
  return (isReady.value && isContent.value && folders.value)
    ? (_openBlock(), _createBlock(FolderGrid, {
        key: 0,
        items: folders.value
      }, null, 8, ["items"]))
    : _createCommentVNode("", true)
}
}

})